export default __webpack_public_path__ + "static/media/radio-default.64d029c0.svg";